import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
// Removed CKEditorModule import
// Removed WysiwygComponent import
import {SharedMaterialModule} from './shared-material.module';
import {SharedTranslateModule} from './shared-translate.module';
import {FuseConfirmDialogModule} from 'fuse-core/components/confirm-dialog/confirm-dialog.module';
import {DynamicModule} from '@fuse/components/dynamic/dynamic.module';
import {BasicPageModule} from 'fuse-core/components/basic-page/basic-page.module';
import {GettingStartedModule} from 'fuse-core/components/getting-started/getting-started.module';
import {SelectCheckAllComponent} from './components/select-check-all/select-check-all.component';
import {ActivtyCardComponent} from './components/activty-card/activty-card.component';
import {NgClass, NgIf} from '@angular/common';
import {ProgressionModule} from 'fuse-core/components/progression/progression.module';
import {GenericFileUploadInterfaceComponent} from 'shared/media/generic-file-upload-interface/generic-file-upload-interface.component';
import {MatCardModule} from '@angular/material/card';

@NgModule({
    imports: [
        DynamicModule,
        FuseConfirmDialogModule,
        ProgressionModule,
        BasicPageModule,
        GettingStartedModule,
        SharedMaterialModule,
        SharedTranslateModule,
        NgClass,
        NgIf,
        FormsModule,
        MatCardModule
    ],
    declarations: [
        SelectCheckAllComponent,
        ActivtyCardComponent,
        GenericFileUploadInterfaceComponent,
        // Removed WysiwygComponent from declarations
    ],
    exports: [
        DynamicModule,
        FuseConfirmDialogModule,
        BasicPageModule,
        GettingStartedModule,
        SharedMaterialModule,
        SharedTranslateModule,
        SelectCheckAllComponent,
        ActivtyCardComponent,
        GenericFileUploadInterfaceComponent,
        // Removed WysiwygComponent from exports
    ]
})
export class SharedModule {}
